<template>
	<div style="padding-top:80px">

		<div class="phone-from">
			<span>验证码登录</span>
			<br />
			<span style="font-size: 0.5rem;color:grey;">未注册的手机号验证通过将自动注册</span>
		</div>
		<div class="phone-from">
			<input type="text" v-model="form.phone" placeholder="请输入手机号" />
		</div>
		<div class="phone-from">
			<input type="text" v-model="form.code" placeholder="请输入验证码" />
			<button class="phone-code" @click="getSms">{{send.text}}</button>
		</div>

		<div class="phone-from">
			<button class="phone-login" @click="submit">注册/登录</button>
		</div>


		<div class="phone-read">
			<input style="width: 0.5rem;height: 0.5rem;" type="checkbox" />
			<span style="font-size: 0.5rem;">我已经阅读并同意《服务协议》和《隐私政策》</span>
		</div>


		<!-- 		<p style="padding:0.0rem 2rem;font-size:.7rem;color:#999;text-indent:1.4rem;line-height: 1.0rem;">
			以上信息仅作为认证使用，通过后无法自行修改，请认真核对。如需修改请联系客服。</p>
		<p style="padding:0.0rem 2rem;font-size:.7rem;color:#999;text-indent:1.4rem;line-height: 1.0rem;">
			注1：验证码15分钟内有效，无须重复发送！</p> -->

		<!-- 组件使用 -->
		<syalert ref="syalert_id" />

	</div>
</template>
<style>
	.phone-from {
		position: relative;
		/* 对于下面的获取验证码 按钮相当重要 */
		width: 16rem;
		margin: 1.2rem auto;
	}

	.phone-from span {
		/* background-color: #FFFFFF; */
	}

	.phone-from input {
		width: 12rem;
		height: 1.5rem;
		font-size: .7rem;
		text-indent: .3rem;

		border-bottom: 1px solid grey;
	}

	.phone-code {
		position: absolute;
		right: 4rem;
		top: .3rem;

		width: 4rem;
		height: 1.0rem;

		font-size: .5rem;
		/* line-height: 1.0rem; */
		cursor: pointer;
		border: 1px solid grey;
		border-radius: 1.0rem;

		text-align: center;
		color: grey;
	}

	.phone-login {
		display: block;

		width: 12rem;
		height: 1.5rem;

		font-size: .6rem;
		text-align: center;

		cursor: pointer;
		border: none;
		border-radius: 1.0rem;

		color: white;
		background-color: #00be8c;
	}

	.phone-read {
		position: absolute;
		left: 2rem;
		bottom: 1.0rem;

		margin: 1.2rem auto;
	}
</style>
<script>
	import sy from "@/sy";

	// 组件引入
	import syalert from '@/components/syalert.vue';

	export default {
		// 组件注册
		components: {
			syalert,
		},
		data() {
			return {
				form: {
					phone: '',
					code: '',
					check: '',
				},



				// 得想办法把这些参数抽象出来 避免被污染 方便init重新初始化
				send: {
					is: true,
					time: 120,
					time_run: 0,
					text: '获取验证码',
					text_end: '重新获取',
					inte: '',
				}, 
			}
		},
		methods:
		{
			getSms: function()
			{
				// ----- ----- 实例重命名
				let $_this = this;
				if ($_this.send.is === true) {
					$_this.send.is = false;
					$_this.send.time_run = $_this.send.time;

					sy.http.get({
						url: this.$root.API + 'Auth/GetSms',
						data: {
							phone: $_this.form.phone,
						},
						success: function(res) {
							$_this.$refs.syalert_id.syalert(res.msg);

							if (res.state == '1') {
								$_this.send.inte = setInterval(function() {
									$_this.send.time_run--;
									if ($_this.send.time_run === -1) {
										clearInterval($_this.send.inte);
										$_this.send.is = true;
										$_this.send.text = $_this.send.text_end;
									} else {
										$_this.send.text = $_this.send.time_run + "s";
									}
								}, 1000);
							} else {
								$_this.send.is = true;
							}
						}
					});
				}
			},
			submit: function()
			{

				// ----- ----- 实例重命名
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Auth/Phone',
					data: {
						phone: this.form.phone,
						code: this.form.code,
					},
					success: function(res) {

							if (res.state === '1')
							{
								console.log('获取成功:' + res.data.utoken);

								// 存储 utoken
								localStorage.setItem('utoken', res.data.utoken);
								
								// 回到源头 必须指定去哪????不然跳去哪?
								$_this.$refs.syalert_id.syalert(res.msg, 1000, function()
								{
									// window.history.back();
									$_this.$router.go(-2);
								});
								// $_this.$router.go(-1);
								
							} else {
								$_this.$refs.syalert_id.syalert(res.msg);
							}

					}
				});
			},
			get_phone: function() {

				// ----- ----- 实例重命名
				let $_this = this;
				sy.http.get({
					url: this.$root.API + 'Check/GetPhone',
					success: function(res) {
						$_this.form.phone = res.data.phone;
						$_this.form.check = res.data.phone_check;
					}
				});

			},
		},
		created() {
			
			
			// 初次
			// let pageto = this.$router.currentRoute.query.pageto;
			// if ( pageto )
			// {
			// 	let Base64 = require("js-base64").Base64;
			// 	pageto = Base64.decode(pageto);
			// } 
			// console.log(pageto);
			// 
			//this.get_phone();

			// 回到源头
			// let pageto = $_this.$router.currentRoute.query.pageto;
			// if( pageto )
			// {
			// 	// let Base64 = require("js-base64").Base64;
			// 	// location.href = Base64.decode(pageto); 
			// }else{
			// 	$_this.$router.go(-1);
			// }			
			
			
		},
		mounted() {}

	}
</script>